import React, { useRef, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { CiStreamOn } from 'react-icons/ci'
import { FaYoutube } from 'react-icons/fa'
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io'
import Slider from 'react-slick/lib/slider'

const KATHA_API_URL = 'https://smvdev.swaminarayansurat.com/admin/all-katha-video-list'
const LIVE_API_URL = 'https://smvdev.swaminarayansurat.com/admin/all-live-video-list'

function getVideoEmbedUrl(video) {
    const videoId = video?.url_key || video?.url?.match(/(?:v=|youtu\.be\/)([\w-]{11})/)?.[1]

    if (!videoId) return ''

    return `https://www.youtube.com/embed/${videoId}?rel=0&version=3&enablejsapi=1`
}

function NextArrow({ onClick }) {
    return (
        <>
            <div className='rounded-[100px] text-black hover:text-white bg-white hover:bg-hoverprimary w-10 h-10 mr-4 transition-all flex items-center justify-center cursor-pointer' onClick={onClick}>
                <IoIosArrowForward className='mx-auto text-xl' />
            </div>
        </>
    )
}
function PrevArrow({ onClick }) {
    return (
        <>
            <div className='rounded-[100px] text-black hover:text-white bg-white hover:bg-hoverprimary w-10 h-10 mr-4 transition-all flex items-center justify-center cursor-pointer' onClick={onClick}>
                <IoIosArrowBack className='mx-auto text-xl' />
            </div>
        </>
    )
}

export default function Youtube_live() {
    const liveSliderRef = useRef(null)
    const dhamSliderRef = useRef(null)
    const [featuredVideos, setFeaturedVideos] = useState([])
    const [sliderVideos, setSliderVideos] = useState([])

    useEffect(() => {
        fetch(KATHA_API_URL)
            .then((res) => res.json())
            .then((data) => {
                const list = Array.isArray(data?.data) ? data.data.filter((item) => item?.visibility !== false) : []
                setFeaturedVideos(list)
            })
            .catch((err) => {
                console.error('Error fetching katha videos:', err)
                setFeaturedVideos([])
            })

        fetch(LIVE_API_URL)
            .then((res) => res.json())
            .then((data) => {
                const list = Array.isArray(data?.data) ? data.data.filter((item) => item?.visibility !== false) : []
                setSliderVideos(list)
            })
            .catch((err) => {
                console.error('Error fetching live videos:', err)
                setSliderVideos([])
            })
    }, [])

    const liveSetting = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        autoplay: true,
        slidesToShow: 2,
        slidesToScroll: 1,
    }

    const dhamSetting = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        autoplay: true,
        slidesToShow: 3,
        slidesToScroll: 1,
    }

    return (
        <>
            <div className='py-20'>
                <div className='max-w-7xl mx-auto px-4' style={{ fontFamily: 'Philosopher, sans-serif' }}>
                    <div className='flex items-center justify-center gap-7 mb-8'>
                        <div className='w-[70px] h-[70px] rounded-full bg-primary text-white flex items-center justify-center text-4xl'><FaYoutube /></div>
                        <h2 className='text-6xl'>Watch <span className='text-primary mb-9'>Live</span></h2>
                    </div>
                    
                    <div className='rounded-[30px] bg-[#FFF5F3] p-10 shadow-lg'>
                        {sliderVideos.length > 0 && (
                            <div className='mt-10'>
                                <div className='flex items-center '>
                                    <div className='flex items-center mb-6'>
                                        <CiStreamOn className='text-4xl mr-2 text-primary' />
                                        <span className='text-darkgray text-2xl font-medium'>Live Katha</span>
                                    </div>
                                    <div className='ml-auto flex items-center'>
                                        <PrevArrow onClick={() => liveSliderRef.current?.slickPrev()} />
                                        <NextArrow onClick={() => liveSliderRef.current?.slickNext()} />
                                    </div>
                                </div>
                                <Slider ref={liveSliderRef} {...liveSetting} className="-mx-2">
                                    {featuredVideos.map((video, index) => {
                                        const embedUrl = getVideoEmbedUrl(video)

                                        if (!embedUrl) return null

                                        return (
                                            <div className='px-2' key={`${video._id || video.url_key || index}`}>
                                                <div className='rounded-2xl p-3 bg-white aspect-video'>
                                                    <iframe
                                                        className='rounded-2xl overflow-hidden'
                                                        width="100%"
                                                        height="100%"
                                                        src={embedUrl}
                                                        title={video.title || 'Ladila Shree Ghanshyam Maharaj Darshan | SMVedroad'}
                                                        frameBorder="0"
                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                        referrerPolicy="strict-origin-when-cross-origin"
                                                        allowFullScreen
                                                    ></iframe>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </Slider>
                            </div>
                        )}
                        {sliderVideos.length > 0 && (
                            <div className='mt-10'>
                                <div className='flex items-center '>
                                    <div className='flex items-center mb-6'>
                                        <CiStreamOn className='text-4xl mr-2 text-primary' />
                                        <span className='text-darkgray text-2xl font-medium'>6 Dham Darshan</span>
                                    </div>
                                    <div className='ml-auto flex items-center'>
                                        <PrevArrow onClick={() => dhamSliderRef.current?.slickPrev()} />
                                        <NextArrow onClick={() => dhamSliderRef.current?.slickNext()} />
                                    </div>
                                </div>
                                <Slider ref={dhamSliderRef} {...dhamSetting} className="-mx-2">
                                    {sliderVideos.map((video, index) => {
                                        const embedUrl = getVideoEmbedUrl(video)

                                        if (!embedUrl) return null

                                        return (
                                            <div className='px-2' key={`${video._id || video.url_key || index}`}>
                                                <div className='rounded-2xl p-3 bg-white aspect-video'>
                                                    <iframe
                                                        className='rounded-2xl overflow-hidden'
                                                        width="100%"
                                                        height="100%"
                                                        src={embedUrl}
                                                        title={video.title || 'Ladila Shree Ghanshyam Maharaj Darshan | SMVedroad'}
                                                        frameBorder="0"
                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                        referrerPolicy="strict-origin-when-cross-origin"
                                                        allowFullScreen
                                                    ></iframe>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </Slider>
                            </div>
                        )}
                    </div>

                    <div className='flex justify-center mt-10'>
                        <Link
                            to='/videos'
                            className='inline-flex items-center gap-2 rounded-full bg-primary px-6 py-3 text-sm font-semibold uppercase tracking-wide text-white shadow-md transition-all duration-200 hover:bg-hoverprimary hover:shadow-lg'
                        >
                            <span>View More</span>
                            <IoIosArrowForward className='text-base' />
                        </Link>
                    </div>
                </div>
            </div>
        </>
    )
}
